import styled, { css } from "styled-components";
import { Button as ButtonAnt } from "antd";
import { InformationCircle } from "../../styles/Icons";

export const Container = styled.div`
  width: 100%;
  overflow-x: auto;

  .ant-table-wrapper {
    overflow-x: auto;
  }

  .ant-table {
    min-width: 800px;
  }

  @media (max-width: 768px) {
    .ant-table-cell {
      padding: 8px 6px !important;
      font-size: 0.85rem;
    }

    button {
      padding: 0 8px;
      font-size: 0.8rem;
      height: 28px;
    }
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const BoxSearch = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const BoxActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (max-width: 768px) {
    gap: 0.25rem;
    flex-wrap: wrap;
  }
`;

interface IButton {
  actionType:
    | "default"
    | "send"
    | "inactivate"
    | "activate"
    | "open_courses"
    | "update_magic_link";
}

export const Button = styled(ButtonAnt)<IButton>`
  border-radius: 0.3rem;
  color: var(--white);

  &&&:disabled {
    background-color: #d4d4d4;
    color: #a09d9d;
    &&&:hover {
      background-color: #d4d4d4;
      color: var(--white);
    }
  }

  ${({ actionType }) => {
    if (actionType === "default") {
      return css`
        background-color: var(--gray-100);
        &&&:hover,
        &&&:focus,
        &&&:focus-within {
          background-color: rgb(189, 189, 189);
          color: var(--white);
        }
        &.ant-btn-loading {
          background-color: rgb(210, 210, 210);
          color: var(--white);
        }
      `;
    }
    if (actionType === "send" || actionType === "update_magic_link") {
      return css`
        background-color: #1890ff;
        &&&:hover,
        &&&:focus,
        &&&:focus-within {
          background-color: rgb(53, 134, 209);
          color: var(--white);
        }
        &.ant-btn-loading {
          background-color: rgb(102, 174, 238);
          color: var(--white);
        }
      `;
    }
    if (actionType === "inactivate") {
      return css`
        background-color: var(--red-600);
        &&&:hover,
        &&&:focus,
        &&&:focus-within {
          background-color: rgb(209, 53, 53);
          color: var(--white);
        }
        &.ant-btn-loading {
          background-color: rgb(229, 115, 115);
          color: var(--white);
        }
      `;
    }
    if (actionType === "activate") {
      return css`
        background-color: var(--green-700);
        &&&:hover,
        &&&:focus,
        &&&:focus-within {
          background-color: rgb(45, 124, 45);
          color: var(--white);
        }
        &.ant-btn-loading {
          background-color: rgb(85, 164, 85);
          color: var(--white);
        }
      `;
    }
    if (actionType === "open_courses") {
      return css`
        background-color: var(--orange-150);
        &&&:hover,
        &&&:focus,
        &&&:focus-within {
          background-color: rgb(255, 132, 0);
          color: var(--white);
        }
        &.ant-btn-loading {
          background-color: rgb(255, 170, 80);
          color: var(--white);
        }
      `;
    }
  }}

  @media (max-width: 768px) {
    padding: 0 8px;
    font-size: 0.8rem;
    height: 28px;
  }
`;

export const InfoIcon = styled(InformationCircle)`
  color: var(--orange-250);
  width: 1rem;
  height: 1rem;
`;

interface IStatusSpan {
  status: "success" | "error" | "info";
}

export const StatusSpan = styled.span<IStatusSpan>`
  color: ${({ status }) => {
    switch (status) {
      case "success":
        return "#52c41a";
      case "error":
        return "#ff4d4f";
      case "info":
      default:
        return "#1890ff";
    }
  }};
  font-weight: bold;
`;
